import { Box, TextField, Grid, Button } from "@mui/material";
import Header from "../../../components/Header";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const Customization = ({
  onHandleNftCustomizationInputChange,
  onHandleCustomLogo,
  nftCustomizationDetails,
}) => {
  return (
    <Box mt="20px" ml="16px">
      <Header title="Branding Details" subtitle="Fill the required field" />
      
      <Accordion expanded={true} style={{ width : '900px' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="page-logo-content"
          id="page-logo-header"
        >
          <Typography style={{ color : '#006A50' }}><b>Upload your logo on page :</b></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <Grid item md={6} xs={6} sm={6}>
                <Box
                  component="img"
                  sx={{
                    width: 400,
                    maxHeight: { xs: 233, md: 167 },
                    maxWidth: { xs: 350, md: 250 },
                  }}
                  src={nftCustomizationDetails.customLogo}
                />
                <input
                  type="file" 
                  id="customLogo" 
                  name="customLogo" 
                  accept="image/png, image/jpeg, image/jpg"
                  onChange={onHandleCustomLogo}
                />
            </Grid>
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion style={{ width : '900px' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="connect-wallet-button-content"
          id="connect-wallet-button-header"
        >
          <Typography style={{ color : '#006A50' }}><b>Connect Wallet Button Customisation :</b></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          <Box
          sx={{ display: 'flex' }}
          alignItems="center"
          justifyContent="center"
          >
            <Button
            style={{ 
              backgroundColor : nftCustomizationDetails.connectWalletButtonColor,
              color : nftCustomizationDetails.connectWalletButtonTextColor,
            }}
            >
            {nftCustomizationDetails.connectWalletButtonText}
            </Button>
          </Box>
          <Grid container spacing={3}>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color : '#000080'}}><b>Button Color</b></p>
              <TextField
                name="connectWalletButtonColor"
                variant="outlined"
                size="small"
                type="color"
                fullWidth
                sx={{ boxShadow: 2 }}
                value={nftCustomizationDetails.connectWalletButtonColor}
                onChange={onHandleNftCustomizationInputChange}
                required
              />
            </Grid>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color : '#000080'}}><b>Button Text Color</b></p>
              <TextField
                name="connectWalletButtonTextColor"
                variant="outlined"
                type="color"
                size="small"
                fullWidth
                sx={{ boxShadow: 2 }}
                value={nftCustomizationDetails.connectWalletButtonTextColor}
                onChange={onHandleNftCustomizationInputChange}
                required
              />
            </Grid>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color : '#000080'}}><b>Button Text</b></p>
              <TextField
                name="connectWalletButtonText"
                variant="outlined"
                type="text"
                size="small"
                fullWidth
                sx={{ boxShadow: 2 }}
                value={nftCustomizationDetails.connectWalletButtonText}
                onChange={onHandleNftCustomizationInputChange}
                required
              />
            </Grid>
          </Grid>
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion style={{ width : '900px' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="buy-nfts-button-content"
          id="buy-nfts-button-header"
        >
          <Typography style={{ color : '#006A50' }}><b>Buy NFTs Button Customisation :</b></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          <Box
          sx={{ display: 'flex' }}
          alignItems="center"
          justifyContent="center"
          >
            <Button
            style={{ 
              backgroundColor : nftCustomizationDetails.buyNFTButtonColor,
              color : nftCustomizationDetails.buyNFTButtonTextColor,
            }}
            >
            {nftCustomizationDetails.buyNFTButtonText}
            </Button>
          </Box>
          <Grid container spacing={3}>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color : '#000080'}}><b>Button Color</b></p>
              <TextField
                name="buyNFTButtonColor"
                variant="outlined"
                type="color"
                size="small"
                fullWidth
                required
                sx={{ boxShadow: 2 }}
                value={nftCustomizationDetails.buyNFTButtonColor}
                onChange={onHandleNftCustomizationInputChange}
              />
            </Grid>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color : '#000080'}}><b>Button Text Color</b></p>
              <TextField
                name="buyNFTButtonTextColor"
                variant="outlined"
                type="color"
                size="small"
                fullWidth
                sx={{ boxShadow: 2 }}
                value={nftCustomizationDetails.buyNFTButtonTextColor}
                onChange={onHandleNftCustomizationInputChange}
                required
              />
            </Grid>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color : '#000080'}}><b>Button Text</b></p>
              <TextField
                name="buyNFTButtonText"
                variant="outlined"
                type="text"
                size="small"
                fullWidth
                sx={{ boxShadow: 2 }}
                value={nftCustomizationDetails.buyNFTButtonText}
                onChange={onHandleNftCustomizationInputChange}
                required
              />
            </Grid>
          </Grid>
          </Typography>
        </AccordionDetails>
      </Accordion>


      <Accordion style={{ width : '900px' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="customise-page-message-content"
          id="customise-page-message-header"
        >
          <Typography style={{ color : '#006A50' }}><b>Customise Page Message :</b></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          <Grid container spacing={3}>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color : '#000080'}}><b>Restricted Content Message Header</b></p>
              <TextField
                name="restrictedContentMessageHeader"
                variant="outlined"
                type="text"
                size="small"
                fullWidth
                sx={{ boxShadow: 2 }}
                value={nftCustomizationDetails.restrictedContentMessageHeader}
                onChange={onHandleNftCustomizationInputChange}
              />
           
            </Grid>
            
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color : '#000080'}}><b>Restricted Content Message</b></p>
              <TextField
                name="restrictedContentMessage"
                variant="outlined"
                type="text"
                size="small"
                fullWidth
                sx={{ boxShadow: 2 }}
                value={nftCustomizationDetails.restrictedContentMessage}
                onChange={onHandleNftCustomizationInputChange}
              />
            </Grid>
          </Grid>
            <Grid container spacing={3}>
              <Grid item md={6} xs={6} sm={6}>
                <p style={{ color : '#000080'}}><b>Error Content Message Header</b></p>
                <TextField
                  name="errorMessageHeader"
                  variant="outlined"
                  type="text"
                  size="small"
                  fullWidth
                  sx={{ boxShadow: 2 }}
                  value={nftCustomizationDetails.errorMessageHeader}
                  onChange={onHandleNftCustomizationInputChange}
                />
              </Grid>
              <Grid item md={6} xs={6} sm={6}> 
                <p style={{ color : '#000080'}}><b>Error Content Message</b></p>
                <TextField
                  name="errorMessage"
                  variant="outlined"
                  type="text"
                  size="small"
                  fullWidth
                  sx={{ boxShadow: 2 }}
                  value={nftCustomizationDetails.errorMessage}
                  onChange={onHandleNftCustomizationInputChange}
                />
              </Grid>
            </Grid>
          </Typography>
        </AccordionDetails>
      </Accordion>
      
      
      <Accordion style={{ width : '900px' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="redirection-url-content"
          id="redirection-url-header"
        >
          <Typography style={{ color : '#006A50' }}><b>Redirection URL Details :</b></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          <Grid container spacing={3}>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color : '#000080'}}><b>Buy NFT Redirection Link</b></p>
              <TextField
                name="linkToBuyNft"
                variant="outlined"
                type="text"
                size="small"
                fullWidth
                sx={{ mt: 2, boxShadow: 2 }}
                value={nftCustomizationDetails.linkToBuyNft}
                onChange={onHandleNftCustomizationInputChange}
                required
              />
            </Grid>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color : '#000080'}}><b>Home Page Redirection Link</b></p>
              <TextField
                name="homePageRedirectionLink"
                variant="outlined"
                type="text"
                size="small"
                fullWidth
                sx={{ mt: 2, boxShadow: 2 }}
                value={nftCustomizationDetails.homePageRedirectionLink}
                onChange={onHandleNftCustomizationInputChange}
                required
              />
            </Grid>
          </Grid>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default Customization;
